export const specialTaxTypes = {
  eu_oss_vat: {
    id: 'eu-oss-vat',
    name: 'EU OSS VAT',
    iso3: 'EUO',
    iso2: 'EU',
    numeric_code: '',
    phone_code: '',
    capital: '',
    currency: 'EUR',
    currency_name: 'Euro',
    currency_symbol: '€',
    tld: '',
    native: 'EU OSS VAT',
    region: 'Europe',
    subregion: '',
    latitude: '',
    longitude: '',
    emoji: '🇪🇺',
    hasStates: false,
  },
  eu_vat: {
    id: 'eu-vat',
    name: 'EU VAT',
    iso3: 'EUV',
    iso2: 'EU',
    numeric_code: '',
    phone_code: '',
    capital: '',
    currency: 'EUR',
    currency_name: 'Euro',
    currency_symbol: '€',
    tld: '',
    native: 'EU VAT',
    region: 'Europe',
    subregion: '',
    latitude: '',
    longitude: '',
    emoji: '🇪🇺',
    hasStates: false,
  },
};
